module.exports = __webpack_public_path__ + "media/images/alphab-d5ec6040981876ff0e172d3b5d634b8d.png";